import { useLocation, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { gridContainterVariants, gridCubeVariants } from "../utilities/customHooks";

function BeyondWorkDetail() {
  const navigate = useNavigate();  
  const location = useLocation();
  const { exp } = location.state || {};

  if (!exp) {
    return <div>No Data Found</div>;
  }

  return (
    <>
      <motion.div
        className="projDetail"
        variants={gridContainterVariants}
        initial="hidden"
        animate="show"
      >
        <a className="goBack" onClick={() => navigate(-1)}></a>
        <h2>{exp.title}</h2>
        <motion.div variants={gridCubeVariants} className="contentSection">
          <div className="banner"><img src={exp.thumbnail} /></div>  
          <div
            className="detailsContent"
            dangerouslySetInnerHTML={{ __html: exp.content }}
          />
        </motion.div>
      </motion.div>
    </>
  );
}
export default BeyondWorkDetail;
